import axios from 'axios';
import type { INotificationSettings } from '@bb/domain/dist/types';

const getNotificationSettings = async () => {
  const { data } = await axios.get<INotificationSettings>(
    '/user/current/notifications',
  );

  return data;
};

export default getNotificationSettings;
